import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="nav-links">
        <Link
          to="/"
          className={location.pathname === "/" ? "nav-link active" : "nav-link"}
        >
          Home
        </Link>
        <Link
          to="/about"
          className={
            location.pathname === "/about" ? "nav-link active" : "nav-link"
          }
        >
          About
        </Link>
        <Link
          to="/support"
          className={
            location.pathname === "/support" ? "nav-link active" : "nav-link"
          }
        >
          Support
        </Link>
        <Link
          to="/privacy"
          className={
            location.pathname === "/privacy" ? "nav-link active" : "nav-link"
          }
        >
          Privacy Policy
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;

